import React from "react";
import { ExternalLink } from "lucide-react";
import { dynType, dynPrio } from "@/lib/metaDynamic";
import { initials } from "@/lib/meta";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

export default function IssueCard({ issue, users, onClick, draggable, onDragStart, onDragEnd, dragging }) {
  const T = dynType(issue.issue_type);
  const P = dynPrio(issue.priority);
  const assignee = users?.find(u => u.id === issue.assignee_id);
  return (
    <div
      draggable={draggable}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onClick={onClick}
      data-testid={`issue-card-${issue.key}`}
      className={cn(
        "group border border-border bg-card rounded-md p-3 cursor-pointer transition-colors hover:border-primary/50 select-none relative",
        dragging && "opacity-40"
      )}
    >
      <div className="text-sm leading-snug mb-2 line-clamp-3">{issue.summary}</div>
      <div className="flex items-center gap-2 text-xs">
        <T.icon className={cn("w-3.5 h-3.5", T.cls)} />
        <a
          href={`/issues/${issue.key || issue.id}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          className="font-mono text-[11px] text-muted-foreground hover:text-primary hover:underline flex items-center gap-1"
          title="Open in new tab"
        >
          <span>{issue.key}</span>
          <ExternalLink className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
        </a>
        <P.icon className={cn("w-3.5 h-3.5 ml-1", P.cls)} />
        {issue.story_points != null && (
          <span className="ml-auto inline-flex items-center justify-center w-5 h-5 rounded-full bg-secondary text-[10px] font-mono font-semibold">{issue.story_points}</span>
        )}
        {assignee ? (
          <Avatar className={cn("w-5 h-5", issue.story_points == null && "ml-auto")}>
            <AvatarImage src={assignee.avatar_url} />
            <AvatarFallback className="text-[8px]">{initials(assignee.name)}</AvatarFallback>
          </Avatar>
        ) : (
          <div className={cn("w-5 h-5 rounded-full border border-dashed border-border", issue.story_points == null && "ml-auto")} />
        )}
      </div>
    </div>
  );
}
